import { render, staticRenderFns } from "./DetalleGrupoTeacher.vue?vue&type=template&id=5fca8b39&scoped=true"
import script from "./DetalleGrupoTeacher.vue?vue&type=script&lang=js"
export * from "./DetalleGrupoTeacher.vue?vue&type=script&lang=js"
import style0 from "./DetalleGrupoTeacher.vue?vue&type=style&index=0&id=5fca8b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca8b39",
  null
  
)

export default component.exports